import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import getProfile from 'root/src/client/logic/app/selectors/getProfile'
import { userGroups } from 'root/src/shared/constants/auth'
import { profileRouteMap } from 'root/src/shared/constants/route'
import { GET_USER_DATA } from 'root/src/shared/descriptions/endpoints/endpointIds'
import userRoleSelector from 'root/src/client/logic/auth/selectors/userRoleSelector'
import prop from 'ramda/src/prop'
import { groupDefaultRouteIdMap } from 'root/src/shared/util/groupDefaultRouteIdMap'

const routeMap = {
	[userGroups.user]: () => ({ routeId: groupDefaultRouteIdMap[userGroups.user] }),
	// Publishers land on the campaigns list like every other publisher group. This used to
	// fire two extra requests (brand rewards, drop events) purely to send a publisher who
	// had not finished setting up to account settings instead. That page is gone in the
	// redesign, so both branches resolved to the same destination and the requests were
	// pure cost on every sign-in.
	[userGroups.brand]: () => ({ routeId: groupDefaultRouteIdMap[userGroups.brand] }),
	[userGroups.viewer]: () => ({ routeId: groupDefaultRouteIdMap[userGroups.viewer] }),
	[userGroups.creator]: async ({
		dispatch, getState,
	}) => {
		const state = getState()
		const profile = getProfile(state)

		// that's only a server side case where we won't have profile in state
		if (!profile) {
			const res = await dispatch(apiRequest(GET_USER_DATA))
			if (res.body?.creatorData?.mnemonicId) {
				const { mnemonicId, platform } = res.body.creatorData

				return {
					routeId: profileRouteMap[platform],
					routeParams: { recordId: mnemonicId },
				}
			}

			return { routeId: groupDefaultRouteIdMap[userGroups.creator] }
		}

		const { mnemonicId, platform } = profile

		return {
			routeId: profileRouteMap[platform],
			routeParams: { recordId: mnemonicId },
		}
	},
	[userGroups.admin]: () => ({ routeId: groupDefaultRouteIdMap[userGroups.admin] }),
	[userGroups.agency]: () => ({ routeId: groupDefaultRouteIdMap[userGroups.agency] }),
	[userGroups.agencyAccountManager]: () => ({ routeId: groupDefaultRouteIdMap[userGroups.agencyAccountManager] }),
	[userGroups.brandUser]: () => ({ routeId: groupDefaultRouteIdMap[userGroups.brandUser] }),
	[userGroups.brandAdmin]: () => ({ routeId: groupDefaultRouteIdMap[userGroups.brandAdmin] }),
}

export const getDefaultRoute = ({ dispatch, getState }) => {
	const state = getState()
	const userRole = userRoleSelector(state)
	const roleSpecificHandling = prop(userRole, routeMap)
	return roleSpecificHandling({
		dispatch,
		getState,
	})
}
